module.exports = __webpack_public_path__ + "img/up-arrow.cc168342.svg";